module.exports = __webpack_public_path__ + "static/media/dungeon_floor_s2.6d2f7778.png";